"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _immutable = require("immutable");

var _index = require("../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xfnuhy-Shortcode",
  styles: "margin-top:0;margin-bottom:16px;&:first-of-type{margin-top:0;};label:Shortcode;"
} : {
  name: "1xfnuhy-Shortcode",
  styles: "margin-top:0;margin-bottom:16px;&:first-of-type{margin-top:0;};label:Shortcode;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

class Shortcode extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      field: (0, _immutable.Map)()
    });
  }

  componentDidMount() {
    const {
      node,
      typeOverload
    } = this.props;
    const plugin = (0, _index.getEditorComponents)().get(typeOverload || node.data.get('shortcode'));
    const fieldKeys = ['id', 'fromBlock', 'toBlock', 'toPreview', 'pattern', 'icon'];
    const field = (0, _immutable.fromJS)((0, _omit2.default)(plugin, fieldKeys));
    this.setState({
      field
    });
  }

  render() {
    const {
      editor,
      node,
      dataKey = 'shortcodeData'
    } = this.props;
    const {
      field
    } = this.state;
    const EditorControl = (0, _index.getEditorControl)();
    const value = dataKey === false ? node.data : (0, _immutable.fromJS)(node.data.get(dataKey));

    function handleChange(fieldName, value, metadata) {
      const dataValue = dataKey === false ? value : node.data.set('shortcodeData', value);
      editor.setNodeByKey(node.key, {
        data: dataValue || (0, _immutable.Map)(),
        metadata
      });
    }

    function handleFocus() {
      return editor.moveToRangeOfNode(node);
    }

    return !field.isEmpty() && (0, _core.jsx)("div", {
      onClick: handleFocus,
      onFocus: handleFocus
    }, (0, _core.jsx)(EditorControl, {
      css: _ref,
      value: value,
      field: field,
      onChange: handleChange,
      isEditorComponent: true,
      isNewEditorComponent: node.data.get('shortcodeNew'),
      isSelected: editor.isSelected(node)
    }));
  }

}

exports.default = Shortcode;